import { MapPin, ExternalLink } from 'lucide-react';

interface LocationDisplayProps {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
}

/**
 * Displays GPS coordinates with a link to Google Maps.
 * Shows "Location not recorded" for null/undefined values.
 * Used in detail page metadata sections to show where checks were performed.
 */
export function LocationDisplay({ latitude, longitude }: LocationDisplayProps) {
  // Handle null/undefined coordinates
  if (latitude == null || longitude == null) {
    return (
      <div className="flex items-center gap-1.5">
        <MapPin className="h-3.5 w-3.5 text-slate-400" />
        <span className="text-slate-400 italic">Location not recorded</span>
      </div>
    );
  }

  // Construct Google Maps URL
  const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

  return (
    <div className="flex items-center gap-1.5">
      <MapPin className="h-3.5 w-3.5 text-slate-500" />
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-slate-700 hover:text-emerald-600 transition-colors"
      >
        <span className="font-mono text-xs">
          {latitude.toFixed(6)}, {longitude.toFixed(6)}
        </span>
        <ExternalLink className="h-3 w-3 opacity-50" />
      </a>
    </div>
  );
}
